import axios from '@/plugins/axios'

export default {
  namespaced: true,

  state: {
    loading: false,
    directories: [],
    files: [],
    directory: 'artists',
    dialog: false
  },

  mutations: {
    setDirectories(state, payload) {
      state.directories = payload
    },
    setFiles(state, payload) {
      state.files = payload
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setSelectedDirectory(state, payload) {
      state.directory = payload
    },
    setDialog(state, payload) {
      state.dialog = payload
    }
  },

  actions: {
    readDirectory({ commit }) {
      commit('setLoading', true)
      axios.admin
        .get('cms/directory')
        .then(r => {
          commit('setDirectories', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },
    readFile({ commit, state }) {
      commit('setLoading', true)
      commit('setFiles', [])
      axios.admin
        .get('cms/file', {
          params: {
            directory: state.directory
          }
        })
        .then(r => {
          commit(
            'setFiles',
            r.data.data.sort((a, b) => b.time - a.time)
          )
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },

    uploadImage({ commit, dispatch, state }, image) {
      axios.admin
        .post('cms/file', {
          image: image,
          directory: state.directory
        })
        .then(
          setTimeout(function() {
            dispatch('readFile')
          }, 1000),
          commit('setDialog', false)
        )
    }
  }
}
